// Applies per-tenant design tokens as CSS variables — proves "branding is
// config, not code" (Prompt §0, §11). Switching tenants reskins the whole app
// with zero code change. Also drives light/dark mode: tenant BRAND colors stay
// constant, structural surfaces flip to a dark palette, and a near-black brand
// primary is auto-lifted so it stays usable on dark backgrounds.

export const GRAPHIKPRO_TOKENS = {
  "--tenant-primary": "240 10% 4%",
  "--tenant-primary-foreground": "0 0% 100%",
  "--tenant-accent": "240 5% 26%",
  "--tenant-accent-foreground": "0 0% 100%",
  "--tenant-surface": "0 0% 100%",
  "--tenant-background": "240 20% 98%",
  "--tenant-border": "240 6% 90%",
  "--tenant-radius-card": "20px",
  "--tenant-radius-button": "12px",
};

const DARK_STRUCTURAL = {
  "--tenant-surface": "240 7% 10%",
  "--tenant-background": "240 10% 6%",
  "--tenant-border": "240 5% 20%",
};

let _tokens = {};
let _mode = "light";
try {
  _mode = localStorage.getItem("fleetos-theme") || "light";
} catch (e) { /* ssr / private mode */ }

export function getThemeMode() {
  return _mode;
}

function _render() {
  const root = document.documentElement;
  root.classList.toggle("dark", _mode === "dark");
  const merged = { ...GRAPHIKPRO_TOKENS, ..._tokens };
  if (_mode === "dark") {
    Object.assign(merged, DARK_STRUCTURAL);
    // Lift a near-black brand primary so buttons/accents remain visible on dark.
    const l = parseFloat((merged["--tenant-primary"] || "").trim().split(/\s+/)[2]);
    if (!isNaN(l) && l < 25) {
      merged["--tenant-primary"] = "0 0% 95%";
      merged["--tenant-primary-foreground"] = "240 10% 9%";
    }
  }
  Object.entries(merged).forEach(([k, v]) => root.style.setProperty(k, v));
}

export function applyTheme(tokens) {
  _tokens = tokens || {};
  _render();
}

export function setThemeMode(mode) {
  _mode = mode;
  try { localStorage.setItem("fleetos-theme", mode); } catch (e) { /* */ }
  _render();
}
